import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import {
  NotificationType,
  TransactionNotificationLogFragment,
} from '@client/graphql/__generated__/types';
import { FC } from 'react';
import { EmailPreview } from './EmailPreview';
import { SmsPreview } from './SmsPreview';

interface NotificationDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  notification: TransactionNotificationLogFragment | null;
}

export const NotificationDetailModal: FC<NotificationDetailModalProps> = ({
  isOpen,
  onClose,
  notification,
}) => {
  if (!notification) {
    return null;
  }

  const template = notification.notificationTemplate;
  const notificationType = template?.notificationType ?? NotificationType.EMAIL;
  const isEmail = notificationType === NotificationType.EMAIL;

  return (
    <Modal isCentered isOpen={isOpen} size="xl" onClose={onClose}>
      <ModalOverlay bg="blackAlpha.700" />
      <ModalContent bg="indigo.900" maxW="600px">
        <ModalHeader color="white" fontSize="lg" pb={2}>
          {isEmail ? 'Email Preview' : 'Text Message Preview'}
        </ModalHeader>
        <ModalCloseButton color="whiteAlpha.600" />
        <ModalBody pb={6}>
          {isEmail ? (
            <EmailPreview notification={notification} />
          ) : (
            <SmsPreview notification={notification} />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
